document.addEventListener('DOMContentLoaded', function () {

    /* ============================================
       READING PROGRESS BAR
       ============================================ */

    var progressBar = document.querySelector('.reading-progress-bar');

    function updateProgress() {
        if (!progressBar) return;
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        progressBar.style.width = progress + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();

    /* ============================================
       ANIMATE CONTENT COMPONENTS ON SCROLL
       ============================================ */

    if ('IntersectionObserver' in window) {
        var animObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                    animObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -30px 0px'
        });

        var animElements = document.querySelectorAll('.info-card, .quote-block, .info-block, .warning-block');
        animElements.forEach(function (el) {
            el.style.opacity = '0';
            el.style.transform = 'translateY(24px)';
            el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
            animObserver.observe(el);
        });
    }

    /* ============================================
       CODE BLOCK COPY BUTTONS
       ============================================ */

    var codeBlocks = document.querySelectorAll('.gh-content pre[class*="language-"]');
    codeBlocks.forEach(function (pre) {
        if (pre.closest('.code-block-wrapper')) return;

        var wrapper = document.createElement('div');
        wrapper.classList.add('code-block-wrapper');

        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);

        var btn = document.createElement('button');
        btn.classList.add('code-copy-btn');
        btn.setAttribute('aria-label', 'Copier le code');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';

        wrapper.appendChild(btn);

        btn.addEventListener('click', function () {
            var code = pre.querySelector('code') || pre;
            var text = code.textContent;

            navigator.clipboard.writeText(text).then(function () {
                btn.classList.add('copied');
                setTimeout(function () {
                    btn.classList.remove('copied');
                }, 2000);
            }).catch(function () {
                var range = document.createRange();
                range.selectNodeContents(pre);
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            });
        });
    });

    /* ============================================
       SHARE BAR FUNCTIONALITY
       ============================================ */

    var shareBar = document.querySelector('.share-bar');
    if (shareBar) {
        var shareUrl = shareBar.getAttribute('data-share-url') || window.location.href;
        var shareTitle = shareBar.getAttribute('data-share-title') || document.title;

        var linkedinBtn = shareBar.querySelector('.share-linkedin');
        if (linkedinBtn) {
            linkedinBtn.href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(shareUrl);
        }

        var twitterBtn = shareBar.querySelector('.share-twitter');
        if (twitterBtn) {
            twitterBtn.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(shareUrl) + '&text=' + encodeURIComponent(shareTitle);
        }

        var facebookBtn = shareBar.querySelector('.share-facebook');
        if (facebookBtn) {
            facebookBtn.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl);
        }

        var copyBtn = shareBar.querySelector('.share-copy');
        if (copyBtn) {
            copyBtn.addEventListener('click', function () {
                navigator.clipboard.writeText(shareUrl).then(function () {
                    copyBtn.classList.add('copied');
                    setTimeout(function () {
                        copyBtn.classList.remove('copied');
                    }, 2000);
                });
            });
        }
    }

    /* ============================================
       TABLE OF CONTENTS FUNCTIONALITY
       ============================================ */

    var tocToggle = document.querySelector('.toc-toggle');
    var tocContent = document.querySelector('.toc-content');

    if (tocToggle && tocContent) {
        tocToggle.addEventListener('click', function () {
            var expanded = tocToggle.getAttribute('aria-expanded') === 'true';
            tocToggle.setAttribute('aria-expanded', !expanded);
            tocContent.classList.toggle('is-open');
        });

        var headings = document.querySelectorAll('.gh-content h2, .gh-content h3');
        if (headings.length > 0) {
            var tocList = document.createElement('ul');
            tocList.classList.add('toc-list');

            headings.forEach(function (heading, index) {
                var id = 'section-' + index;
                heading.id = id;

                var li = document.createElement('li');
                li.classList.add('toc-item');
                if (heading.tagName === 'H3') {
                    li.classList.add('toc-h3');
                }

                var a = document.createElement('a');
                a.href = '#' + id;
                a.textContent = heading.textContent;
                a.setAttribute('data-target', id);

                a.addEventListener('click', function (e) {
                    e.preventDefault();
                    var target = document.getElementById(this.getAttribute('data-target'));
                    if (target) {
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });

                li.appendChild(a);
                tocList.appendChild(li);
            });

            tocContent.innerHTML = '';
            tocContent.appendChild(tocList);
            tocContent.classList.add('is-open');

            var tocLinks = tocContent.querySelectorAll('.toc-item a');

            function updateActiveToc() {
                var scrollPos = window.scrollY + 120;
                var currentId = '';

                headings.forEach(function (heading) {
                    if (heading.offsetTop <= scrollPos) {
                        currentId = heading.id;
                    }
                });

                tocLinks.forEach(function (link) {
                    link.classList.remove('is-active');
                    if (link.getAttribute('data-target') === currentId) {
                        link.classList.add('is-active');
                    }
                });
            }

            window.addEventListener('scroll', updateActiveToc, { passive: true });
            updateActiveToc();
        }
    }
});
